import { ElLoading as Loading } from 'element-plus';
import { createApp } from 'vue';
import VueDisableInterpolation from 'vue-disable-interpolation';
import { i18n } from '#/lang';

export const initApp = () => {
  const app = createApp();
  app.use(i18n);
  app.use(VueDisableInterpolation);
  app.use(Loading.directive);
  return app;
};

export const mountApp = (app) => {
  window.app = app;
  const vm = app.mount('#common_layout');
  window.vm = vm;
};
